import { useState } from "react";
import { getMRRById, addMRR, getMRRs, deleteMRRById, updateMRRById, getGRNsByMRR, getDNsByMRR, } from "../../../Services/inventoryService";
import { getMRRMaterial } from "../../../Services/materialRequestService";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../MRR/constants";
import toast from "react-hot-toast";

export const useMRR = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchAllMRRs = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getMRRs({
        ...filters,
        ...params,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.MRR_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.MRR_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchMRRMaterial = async (mrrId, params) => {
    try {
      const response = await getMRRMaterial(mrrId, params);
      if (response.status === 200) {
        return response.data.results;
      } else {
        toast.error(TOAST_MESSAGES.FAILED_FETCH_MRR);
        return null;
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.FAILED_FETCH_MRR);
      return null;
    }
  };

  const fetchMRRById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getMRRById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.MRR_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.MRR_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const newMRR = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await addMRR(payload);
      if (response.status === 201) {
        data = response.data;
        const msg = TOAST_MESSAGES.MRR_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.MRR_CREATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.CREATE_RETURNNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateMRRDetails = async (mrrId, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await updateMRRById(mrrId, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = TOAST_MESSAGES.UPDATE_MRR_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.UPDATE_MRR_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_MRR_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteMRR = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await deleteMRRById(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.MRR_DELETE);
        data = true;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.FAILED_TO_DELETE_MRR;
        toast.error(msg);
        data = false;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_TO_DELETE_MRR
      );
      data = false;
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchMRRGRNMaterials = async (instanceId) => {
    setLoading(true);
    let data = null;
    try {
      const res = await getGRNsByMRR(instanceId, {
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      data = res?.data || [];

    } catch (err) {
      toast.error(extractErrorMessage(err) || TOAST_MESSAGES.MRR_GRN_FETCH_FAILED);
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchMRRDNMaterials = async (instanceId) => {
    setLoading(true);
    let data = null;
    try {
      const res = await getDNsByMRR(instanceId);
      data = res?.data || [];

    } catch (err) {
      toast.error(extractErrorMessage(err) || TOAST_MESSAGES.MRR_DN_FETCH_FAILED);
    } finally {
      setLoading(false);
      return data;
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchAllMRRs,
    deleteMRR,
    newMRR,
    fetchMRRById,
    updateMRRDetails,
    fetchMRRMaterial,
    fetchMRRGRNMaterials,
    fetchMRRDNMaterials
  };
};
